// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__v8ZIv","toggleWrap":"styles_toggleWrap__2yFIO","content":"styles_content__nWP9h","selectAreaCode":"styles_selectAreaCode__1ur_K"};